import React from 'react';
import { BookOpen } from 'lucide-react';

export function LoreWikiMockup() {
  return (
    <div className="landing-mockup-card">
      <div className="flex items-center gap-2 mb-3">
        <BookOpen className="h-4 w-4 text-purple-400" />
        <span className="font-cinzel text-xs font-bold">Orbe de Zarathos</span>
        <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-purple-500/20 text-purple-400">Artéfact</span>
      </div>
      <p className="text-[11px] text-muted-foreground mb-2 leading-relaxed">
        Forgé par <span className="text-blue-400 underline decoration-dotted cursor-pointer">@Zarathos le Déchu</span> durant
        la <span className="text-green-400 underline decoration-dotted cursor-pointer">@Guerre des Arcanes</span>,
        cet orbe est caché dans les <span className="text-amber-400 underline decoration-dotted cursor-pointer">@Cryptes de Valdris</span>.
      </p>
      <div className="border-t border-border/30 pt-2 mt-2">
        <div className="text-[9px] text-muted-foreground mb-1 font-medium">Backlinks (3)</div>
        <div className="flex flex-wrap gap-1">
          {['Zarathos le Déchu', 'Guerre des Arcanes', 'Cryptes de Valdris'].map((link) => (
            <span key={link} className="text-[9px] px-1.5 py-0.5 rounded bg-muted/50 text-muted-foreground border border-border/20">{link}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
